import { useRef, useEffect } from 'react';

/** 鼠标拖拽 Hook */
const useMouseDrag = swiperStore => {
  const ref = useRef(null);

  useEffect(
    () => {
      const el = ref.current;
      if (!el || !swiperStore) return;

      let startX = 0;
      let isDown = false;

      const handleMouseDown = e => {
        isDown = true;
        startX = e.pageX;
      };

      const handleMouseUp = e => {
        if (!isDown) return;
        isDown = false;
        const endX = e.pageX;
        const distance = endX - startX;

        // 判定滑动距离阈值，触发切换逻辑
        if (Math.abs(distance) > 50) {
          distance > 0 ? swiperStore?.goPrev?.() : swiperStore?.goNext?.();
        }
      };

      el.addEventListener('mousedown', handleMouseDown);
      // 防止事件丢失，鼠标松开事件，判断是否触发切换
      window.addEventListener('mouseup', handleMouseUp);

      return () => {
        el.removeEventListener('mousedown', handleMouseDown);
        window.removeEventListener('mouseup', handleMouseUp);
      };
    },
    [swiperStore]
  );

  return ref;
};
export default useMouseDrag;
